import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { HexColorInput, HexColorPicker, RgbaColorPicker } from "react-colorful";
import { Box, ClickAwayListener } from "@mui/material";

const PREFIX = "ColorPicker";

const classes = {
  picker: `${PREFIX}-picker`,
  popoverStyle: `${PREFIX}-popoverStyle`,
  colorPreview: `${PREFIX}-colorPreview`,
  hexColorInput: `${PREFIX}-hexColorInput`,
  smallPopoverStyle: `${PREFIX}-smallPopoverStyle`,
};

const ColorPickerContainer = styled("div")(({ theme }) => {
  return {
    [`& .${classes.picker}`]: {
      position: "relative",
    },
    [`& .${classes.popoverStyle}`]: {
      position: "absolute",
      bottom: "calc(100% + 2px)",
      left: "28px",
      borderRadius: "9px",
      "& .react-colorful__saturation": {
        borderRadius: "4px 4px 0px 0px",
        border: 0,
      },
      "& .react-colorful__hue": {
        height: "20px",
      },
      "& .react-colorful__alpha": {
        height: "20px",
        borderRadius: "0px 0px 4px 4px",
      },
      "& .react-colorful__saturation-pointer": {
        width: "20px",
        height: "20px",
        borderRadius: "3px",
      },
      "& .react-colorful__hue-pointer, & .react-colorful__alpha-pointer": {
        width: "10px",
        height: "20px",
        borderRadius: "3px",
      },
    },
    [`& .${classes.smallPopoverStyle}`]: {
      position: "absolute",
      bottom: "calc(100% + 2px)",
      borderRadius: "9px",
      "&>:first-of-type": {
        height: "100px",
        width: "100px",
      },
      "& .react-colorful__saturation": {
        borderRadius: "4px 4px 0px 0px",
        border: 0,
      },
      "& .react-colorful__hue": {
        height: "20px",
      },
      "& .react-colorful__alpha": {
        height: "20px",
        borderRadius: "0px 0px 4px 4px",
      },
      "& .react-colorful__saturation-pointer": {
        width: "20px",
        height: "20px",
        borderRadius: "3px",
      },
      "& .react-colorful__hue-pointer, & .react-colorful__alpha-pointer": {
        width: "10px",
        height: "20px",
        borderRadius: "3px",
      },
    },
    [`& .${classes.colorPreview}`]: {
      // width: '28px',
      height: "28px",
      borderRadius: "4px",
      border: "1px solid #fff",
      cursor: "pointer",
    },
    [`& .${classes.hexColorInput}`]: {
      position: "relative",
      "& > input": {
        height: "25px",
        width: "60px",
        position: "absolute",
        top: "0.5rem",
        left: "-5px",
        borderRadius: "3px",
        border: "none",
      },
    },
  };
});

export const PopoverPicker = ({
  color,
  onChange,
  hexColor,
  onChangeHex,
  mode = null,
  width = 28,
  small = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ColorPickerContainer sx={{ width }}>
      {mode === "rgba" ? (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
          <Box className={classes.picker} sx={{ width }}>
            <Box
              className={classes.colorPreview}
              sx={{
                width,
                height: `${width}px !important`,
                backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
              }}
              onClick={() => setIsOpen(!isOpen)}
            />
            <div className={classes.hexColorInput}>
              <HexColorInput prefixed color={hexColor} onChange={onChangeHex} />
            </div>
            {isOpen && (
              <div
                className={
                  small ? classes.smallPopoverStyle : classes.popoverStyle
                }
                style={{
                  backgroundColor: small ? "blue" : "red",
                }}
              >
                <RgbaColorPicker color={color} onChange={onChange} />
              </div>
            )}
          </Box>
        </ClickAwayListener>
      ) : (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
          <div className={classes.picker}>
            <div
              className={classes.colorPreview}
              style={{ backgroundColor: color }}
              onClick={() => setIsOpen(!isOpen)}
            />

            {isOpen && (
              <div
                className={
                  small ? classes.smallPopoverStyle : classes.popoverStyle
                }
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <HexColorPicker color={color} onChange={onChange} />
                  <HexColorInput
                    prefixed
                    color={hexColor}
                    onChange={onChangeHex}
                    style={{ marginTop: "0.5rem" }}
                  />
                </Box>
              </div>
            )}
          </div>
        </ClickAwayListener>
      )}
    </ColorPickerContainer>
  );
};

export default PopoverPicker;
